export abstract class HomeItemRenderer{
	protected isForMobile = false;
	constructor(protected container:HTMLElement){}
	public abstract render():void;

	protected renderContainer(isForMobile:boolean):HTMLElement{
		var entryContainer = document.createElement("div");
		if(isForMobile){
			entryContainer.classList.add("_entryMobileOnly");
		}
		entryContainer.classList.add("_entry");
		this.container.appendChild(entryContainer);
		return entryContainer;
	}
}